import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="San Francisco">
                                <h1>Custom Software Development Company In <span>San Francisco</span></h1>
                            </div>
                            <p className="main_para">TekRevol offers diverse solutions considering multiple businesses associated with different industries. Therefore, you can scale your business growth through our industry-recognized software development company San Francisco, ready to connect with you today. We offer end-to-end software solutions at the hands of world-class developers.</p>
                            <Link to="/contact"
                            className="border_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;